/** A referential list of actions: no tenant, no parameter. */
class FetchAuditActions {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchAuditActions;
